import {Context, Getters} from "vuex-smart-module";
import RootState from "@/store/modules/root-state";
import {Store} from "vuex";
import {store} from "@/store";
import root, {DEFAULT_REQUIRED_MODULES} from "@/store/modules/index";

export default class RootGetters extends Getters<RootState> {
    declare private rootContext: Context<typeof root>;

    $init(_store: Store<typeof store>): void {
        this.rootContext = root.context(_store);

        super.$init(_store);
    }

    get isInitialized(): boolean {
        const modules = this.rootContext.modules;

        return DEFAULT_REQUIRED_MODULES.every(
            moduleKey => modules[moduleKey].state.isInitialized
        );
    }
}
